<template>
  <div class="section content">
    <validation-observer
      ref="form-user-login-info"
      tag="form"
    >
      <div class="columns">
        <div class="column has-text-centered">
          <h2 class="title is-2">
            User Login Information
          </h2>
          <div class="subtitle is-2">
            The password must be at least 12 characters long and contain the following: upper case (A-Z), lower case (a-z), number (0-9) and special character (e.g. !@#$%^&*).
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column is-one-third">
          <textbox-vee
            id="emailAddress"
            v-model="loginInfo.emailAddress"
            rules="required|email"
            required
            placeholder="E-mail"
            autocomplete="off"
          />
        </div>
        <div class="column is-one-third">
          <textbox-vee
            id="password"
            v-model="loginInfo.password"
            type="password"
            placeholder="Password"
            rules="required|phlpass"
            autocomplete="off"
            required
            vid="password"
          />
        </div>
        <div class="column is-one-third">
          <textbox-vee
            id="passwordConfirm"
            v-model="loginInfo.confirmPassword"
            type="password"
            rules="required|confirmed:password"
            placeholder="Repeat Password"
            autocomplete="off"
            required
          />
        </div>
      </div>
    </validation-observer>
  </div>
</template>
<script>
import { controlValueHelpers } from '@/mixins/controlValue';
import { filerScreenHelpers } from '@/mixins/filerScreen';
import { Textbox } from '@phila/phila-ui';
import { withValidation } from 'vee-validate';

const TextboxVee = withValidation(Textbox);

export default {
  name: 'LoginInfo',
  components: {
    TextboxVee,
  },
  mixins: [
    filerScreenHelpers,
    controlValueHelpers,
  ],
  data() {
    return {
      loginInfo: {},
    };
  },
  computed: {},
  watch: {
    loginInfo: {
      async handler (newValue) {
        this.$emit('loginInfo', newValue);
      },
      deep: true,
    },
  },
  async created () {},
  methods: {},
};
</script>